import PropTypes from 'prop-types';
import React from 'react';
// import styles from './cms-prices-selectable.module.scss'
import { Table } from 'antd';
import { formatPrice } from '../../../library/utilities/intl.js';

const CmsPricesSelectable = ({ prices, selectedQuantities = [], currency, disabled = false, onSelectionChange }) => {
    const purchasePrices = (prices?.costs?.purchase_price && typeof prices.costs.purchase_price === 'object')
        ? prices.costs.purchase_price
        : (prices?.purchase_price && typeof prices.purchase_price === 'object')
            ? prices.purchase_price
            : (prices && typeof prices === 'object' && !prices.costs && !prices.total_price && !prices.margin)
                ? prices
                : {};

    const quantitySet = new Set();
    const candidateSources = [
        purchasePrices,
        prices?.total_price,
        prices?.margin,
        prices?.margin_percent,
        prices?.costs?.handling_cost,
        prices?.costs?.transport_cost,
        prices?.costs?.finisher_cost
    ];

    candidateSources.forEach(source => {
        if (source && typeof source === 'object') {
            Object.keys(source).forEach(qty => {
                const parsed = parseInt(qty, 10);
                if (!isNaN(parsed)) {
                    quantitySet.add(parsed);
                }
            });
        }
    });

    const sortedQuantities = Array.from(quantitySet).sort((a, b) => a - b);

    const priceList = sortedQuantities.map((quantity) => {
        const price = purchasePrices?.[quantity] ?? purchasePrices?.[String(quantity)];
        return {
            quantity,
            price: (price !== null && price !== undefined && price !== '') ? formatPrice(price, currency) : 'NA'
        };
    });

    return (
        <Table
            columns={[
                {
                    title: 'Quantity',
                    dataIndex: 'quantity'
                },
                {
                    title: 'Price',
                    dataIndex: 'price'
                },
            ]}
            dataSource={priceList}
            rowKey="quantity"
            pagination={false}
            rowSelection={{
                selectedRowKeys: selectedQuantities,
                getCheckboxProps: () => ({
                    disabled: disabled,
                }),
                onChange: (selectedRowKeys) => {
                    onSelectionChange(selectedRowKeys)
                }
            }}
            onRow={(record) => ({
                onClick: event => {
                    event.preventDefault()
                    if (disabled)
                        return
                    if (selectedQuantities.includes(record.quantity)) {
                        onSelectionChange(selectedQuantities.filter(a => a !== record.quantity))
                    }
                    else {
                        onSelectionChange([...selectedQuantities, record.quantity])
                    }
                }
            })}
        />
    )
    // return (
    //     <div className={styles.wrapper}>
    //         {Object.entries(prices).map(([qty, price]) => (
    //             <div className={`${styles.item} ${selectedQuantities.includes(Number(qty)) ? styles.active : ''}`} key={qty} onClick={() => handleItemClick(String(qty))} >
    //                 <span className={styles.quantity}>{qty}</span>
    //                 <span className={styles.price}>{price || 'NA'}</span>
    //             </div>
    //         ))}
    //         {children}
    //     </div>
    // )
}

CmsPricesSelectable.propTypes = {
    prices: PropTypes.object,
    onSelectionChange: PropTypes.func,
    selectedQuantities: PropTypes.arrayOf(PropTypes.number),
    currency: PropTypes.string,
    disabled: PropTypes.bool,
}

export default CmsPricesSelectable